import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'

// HTTP
import httpRoutes from '@/modules/http/routes'

// AUTH
import authRoutes from '@/modules/auth/routes'

// DOCUMENTS
import documentRoutes from '@/modules/documents/routes'

// ACCOUNT
import accountRoutes from '@/modules/account/routes'

// CUSTOMERS
import customersRoutes from '@/modules/customer/routes'

import purchaseRoutes from '@/modules/purchase/routes'

// POS
import posRoutes from '@/modules/pos/routes'

// SUMMARIES
import summariesRoutes from '@/modules/summaries/routes'

// METRICS
import metricsRoutes from '@/modules/metrics/routes'

// CUADRATURA
import reconciliationsRoutes from '@/modules/reconciliations/routes'

// SIRE
import sireRoutes from '@/modules/sire/routes'

Vue.use(VueRouter)
const routes = [
  ...authRoutes,
  ...accountRoutes,
  ...customersRoutes,
  ...purchaseRoutes,
  ...httpRoutes,
  ...documentRoutes,
  ...posRoutes,
  ...summariesRoutes,
  ...metricsRoutes(store),
  ...reconciliationsRoutes,
  ...sireRoutes
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  store.dispatch('global/CANCEL_PENDING_REQUESTS')
  if (to.meta.requireAuth) {
    if (store.state.auth.token) {
      if (to.meta.requireAccount) {
        if (store.state.auth.account.acc_id) {
          if (!store.state.auth.userAccount['com.axteroid.is_staff']) {
              if (to.meta.permissionsRequired !== undefined && !to.meta.permissionsRequired?.some((l) => store.state.auth?.userAccount?.resource_access?.webapp?.roles?.some((v) => v === l))) {
                next({ name: 'PermissionDenied' })
              } else next()
          } else next()
        } else {
          next({ path: '/account/choose' })
        }
      } else {
        next()
      }
    } else {
      next({
        path: '/auth/signin',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    if (to.name === 'AuthSignUp') {
      if (to.query.invitation) {
        next()
      }
    }
    next()
  }
})

router.afterEach((to, from) => {
  if (store.state.auth.account.acc_id) {
    // track Segment page navigation
    if (process.env.NODE_ENV === 'production') {
      window.analytics.page(to.name)
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = 'Factura X'
  next(true)
})

export default router
